// 앱 부트스트랩이 확정한 테넌트 키를 core 계층에 공급하는 최소 컨텍스트.
// core 는 packages/shared 를 import 할 수 없으므로(계층 방향) 값 주입 방식을 쓴다 —
// apps/*/src/main.js 가 shared/utils/tenant 의 판정 결과를 setTenantKey() 로 넣어준다.
// 소비자(axios 인터셉터)는 요청 시점에 읽으므로 부트스트랩 이후면 항상 값이 있다.
let _tenantKey = null;

export function setTenantKey(key) {
    _tenantKey = key;
}

export function getTenantKey() {
    return _tenantKey;
}
